import { FeedFilterParamType } from 'model';
import { useEffect, useState } from 'react';
import { useLazySearchPostTopicsQuery, useSearchPostTopicsQuery } from '../../api/PostApi';
import { FormValueType } from '../../hooks/useFormValues';
import { useQueryWithDebounce } from '../../hooks/useQueryWithDebounce';
import { FormErrors } from './FormErrors';
// Styles
// eslint-disable-next-line css-modules/no-unused-class
import sharedStyles from '../../styles/Shared.module.css';
// eslint-disable-next-line css-modules/no-unused-class
import formStyles from './FormFields.module.css';
import { SearchBar } from './SearchBar';

export const TopicSearchBox: React.FC<{
	setValues: (value: FormValueType<FeedFilterParamType>) => void;
	topic: string;
	nogap?: boolean;
	errors?: string[];
	label?: string;
	selectOnly?: boolean;
	testId?: string;
}> = ({ setValues, topic, errors, label, selectOnly, nogap, testId }) => {
	const [search, setSearch] = useState(topic);
	const [expandedResultsShow, setExpandedResultsShow] = useState(false);
	let topics: { key: string; value: number }[] | undefined = [];
	const {
		trigger,
		data: searchData,
		isFetching,
		isLoading
	} = useQueryWithDebounce(useLazySearchPostTopicsQuery, 300);
	const { data: allTopics } = useSearchPostTopicsQuery('');

	topics = [{ key: search, value: 0 }];

	if (search.length > 1 && searchData && searchData?.length > 0) {
		const filteredSearchData = searchData.filter(item => item.key !== search);
		topics = topics.concat(filteredSearchData);
	} else {
		topics = search.length > 1 ? topics : allTopics;
	}

	const handleTopicSearch = (value: string) => {
		setSearch(value);
		if (selectOnly !== true) {
			setValues({
				topic: value
			});
		}
	};
	const handleTopicChoose = (value: string) => {
		setSearch(value);
		setValues({
			topic: value
		});
	};
	const clearSearch = () => {
		setSearch('');
		setValues({
			topic: ''
		});
	};

	useEffect(() => {
		if (topic !== null && topic !== undefined) {
			setSearch(topic);
		}
	}, [topic]);
	return (
		<div className={formStyles.fieldContainer} style={{ marginBottom: nogap ? 0 : 20 }} data-testid={testId}>
			{label && <div className={formStyles.label}>{label}</div>}
			<SearchBar
				placeholder={label}
				value={search}
				onFocus={() => {
					setExpandedResultsShow(true);
				}}
				onBlur={() => setExpandedResultsShow(false)}
				onCancel={clearSearch}
				onClear={clearSearch}
				onChangeAction={e => {
					handleTopicSearch(e.detail.value as string);
					trigger(e.detail.value ? e.detail.value : '');
					if ((e.detail.value as string) !== search) {
						setExpandedResultsShow(true);
					}
				}}
				isFetching={isFetching}
				isLoading={isLoading}
			/>
			{expandedResultsShow && topics && (
				<div className={sharedStyles.searchAutoCompleteContainer}>
					<div className={sharedStyles.expandingScrollArea} style={{ height: topics.length * 45 }}>
						{topics.slice(0, 20).map((item: { key: string; value: number }, index) => {
							return (
								<div
									style={{ paddingRight: '10px' }}
									className={sharedStyles.expandingScrollItem}
									key={item.key}
									onMouseDown={() => {
										handleTopicChoose(item.key);
									}}
								>
									{item.key}
								</div>
							);
						})}
					</div>
				</div>
			)}
			<FormErrors errors={errors} />
		</div>
	);
};
